import { render } from "./CustomerFactors.vue?vue&type=template&id=2e0da0c8&scoped=true"
import script from "./CustomerFactors.vue?vue&type=script&lang=js"
export * from "./CustomerFactors.vue?vue&type=script&lang=js"

import "./CustomerFactors.vue?vue&type=style&index=0&id=2e0da0c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e0da0c8"]])

export default __exports__